import * as React from 'react';
import Box from '@mui/material/Box';
import RadioGroup from '@mui/material/RadioGroup';
import { AvailableTimeslot, AvailableTimeslotWithPhotographers } from '../../types';
import { Hint } from '../../view/Hint';
import { Translate, translateDateFormat } from '../../../../../../../shared/LanguageService';
import { PHOTOGRAPHER_BOOKING_DATE_FORMAT } from '../../bookingDateSelect/state/dateHelper';
import { hasDifferentTimeSelected } from '../../availableTimeslotsSection/state/availableTimeslotHelpers';
import { AvailableTimeslotCard } from '../../availableTimeslotsSection/view/AvailableTimeslotCard';

type AvailableTimeSlotsSectionProps = {
    showHint: boolean;
    availableTimeslotsPerHour: Map<string, AvailableTimeslotWithPhotographers[]>;
    bottomOffset: number;
    selectedDifferentTime: AvailableTimeslot | null;
    selectedTimeslot: string | null;
    onChange: (timeslot: string) => void;
};

/**
 * TODO: At some point it would probably make more sense to transform
 *       the data to suite AvailableTimeslotsSection, if possible, rather
 *       than using two similar, but not entirely sure though...
 */

export function AvailableTimeCentricTimeslotSection({
    showHint,
    availableTimeslotsPerHour,
    bottomOffset,
    selectedDifferentTime,
    selectedTimeslot,
    onChange
}: AvailableTimeSlotsSectionProps) {
    let availableTimeslots: AvailableTimeslotWithPhotographers[] = [];
    let numberOfTimeslots: number[] = [];

    availableTimeslotsPerHour.forEach((timeslots) => {
        availableTimeslots.push(timeslots[0]);
        numberOfTimeslots.push(timeslots.length);
    });

    return (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '8px',
                paddingBottom: `${bottomOffset + 16}px`,
                gap: '4px'
            }}
        >
            <Hint showHint={showHint}>
                {Translate('se360/photographerbooking/customer/calendar/available-timeslot-hint')}
            </Hint>

            <RadioGroup
                name="available-time-slot"
                aria-label={Translate('se360/photographerbooking/customer/calendar/title')}
                value={selectedTimeslot}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    let val = event.target.value;
                    onChange(val);
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '6px',
                        gap: '4px'
                    }}
                >
                    {availableTimeslots.map(({ timeslot }, index) => (
                        <AvailableTimeslotCard
                            key={timeslot.time}
                            time={timeslot.time}
                            numberOfSlots={numberOfTimeslots[index]}
                            date={translateDateFormat(
                                new Date(timeslot.date),
                                PHOTOGRAPHER_BOOKING_DATE_FORMAT
                            )}
                            forecast={timeslot.forecast}
                            selectedDifferentTime={
                                hasDifferentTimeSelected(timeslot, selectedDifferentTime)
                                    ? selectedDifferentTime
                                    : null
                            }
                        />
                    ))}
                </Box>
            </RadioGroup>
        </Box>
    );
}
